<template>
	<div class="container">
		<div class="header">
			<div class="logo" @click="goHome">
				<div style="float: left;width: 50px;">
					<img src="@/assets/index/header/logo.png" width="50px" height="50px" />
				</div>
				<div style="float: left;margin-left: 10px;">
					<h1>专 利 管 理 运 营 平 台</h1>
					<span>Patent management and operation platform</span>
				</div>
			</div>
			<div class="nav-list" id="header-title-gide">
				<span >
					<span v-for="(item,i) in dataList" :key="i">
						<span class="nav-list-title" @click="openUrl(item.url)">{{item.title}}</span>
						<span v-if="i != dataList.length-1"> | </span>
					</span>
				</span>
			</div>
		</div>

	</div>

</template>

<script>
	import {headerData} from '@/view/data/header.js'
	export default {
		name: 'indexheader',
		data() {
			return {
				dataList:headerData
			};
		},
		methods:{
			goHome:function(){
				 this.$router.push({path: '/'});
			},
			openUrl:function(url){
				window.open(url);
			}
		}
	}
</script>

<style scoped>
	.header {
		height: 80px;
		padding: 15px 0;
		position: relative;
		overflow: hidden;
	}
	
	.logo {
		width: 320px;
		height: 50px;
		float: left;
		position: relative;
		cursor: pointer;
	}
	
	.nav-list {
		width: 320px;
		margin: 0 auto;
		position: absolute;
		right: 0;
		bottom: 15px;
		text-align: right;
	}
	
	.nav-list-title {
		font-size: 15px;
		cursor: pointer;
	}
</style>


// WEBPACK FOOTER //
// src/view/layout/header/index.vue